module.exports = __webpack_public_path__ + "img/073-togo.c9b912ea.svg";